import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Switch, Row, Col, Select, Tooltip } from "antd";
import { Doctor, emptyDoctor } from "./interfaces/doctor";
import { signIn } from "../auth/utils";
import { SignedInContext } from "../AppEnv";
import { getStudio } from "../studio/utils";
import { Studio, emptyStudio } from "../studio/interfaces";
import { RuleObject } from "antd/es/form";
// Importa i validator dal file utils (assicurati che il percorso sia corretto)
import { checkDoctorEmailAvailability, checkDoctorUsernameAvailability, checkUsernameAvailability } from "../subscription/utils";

interface DoctorFormProps {
  onSubmit: (doctor: Doctor) => void;
}

const EditDoctorInfoX: React.FC<DoctorFormProps> = ({ onSubmit }) => {
  const [doctor, setDoctor] = useState(emptyDoctor);

  const handleInputChange = (field: keyof Doctor, value: string | boolean) => {
    setDoctor((prevDoctor: any) => ({ ...prevDoctor, [field]: value }));
  };
  const { signedInDoctor } = useContext(SignedInContext);

  const [studio, setStudio] = useState(emptyStudio);

  useEffect(() => {
    getStudio(signedInDoctor)
      .then((fetchedStudio: Studio) => {
        setStudio({
          ...fetchedStudio,
        });
      })
      .catch((err) => console.error(err));
  }, [signedInDoctor]);

  const studiox = signedInDoctor.medicalStudioId;

  const onFinish = () => {
    console.log("Dati prima dell'invio:", doctor);
    // ... (altro codice)
    console.log("Dati dopo l'invio:", doctor);
    console.log("Opzione selezionata: " + studio.fullName);
    onSubmit(doctor);
    setDoctor(emptyDoctor); // Reset form after submission
  };

  const validatePasswordConfirmation = (_: any, value: string | undefined) => {
    if (value !== doctor.password) {
      return Promise.reject(new Error("Le password non corrispondono."));
    }
    return Promise.resolve();
  };

  // Funzione già esistente per il controllo di lunghezza (opzionale, se vuoi mantenerla separata)
  const validateUsername = (_: any, value: string) => {
    if (value.length < 4) {
      return Promise.reject(
        new Error("L'username deve contenere almeno 4 lettere")
      );
    }
    return Promise.resolve();
  };

  // Nuovo validator asincrono per la disponibilità dello username
  const validateUsernameAvailability = async (_: any, value: string) => {
    if (!value) {
      return Promise.reject(new Error("Inserisci l'username"));
    }
    if (value.length < 4) {
      return Promise.reject(
        new Error("L'username deve contenere almeno 4 lettere")
      );
    }
    const availabilityStatus = await checkDoctorUsernameAvailability(value);
    console.log("Risposta del server per username:", availabilityStatus, "il value è:", value);
    if (Number(availabilityStatus) === 1) {
      return Promise.reject(new Error("Username già esistente, scegli un altro!"));
    } else if (Number(availabilityStatus) !== 0) {
      return Promise.reject(new Error("Errore di connessione o interno"));
    }
    return Promise.resolve();
  };

  // Nuovo validator asincrono per la disponibilità dell'email
  const validateDoctorEmail = async (_: any, value: string) => {
    if (!value) {
      return Promise.reject(new Error("Inserisci un'email valida!"));
    }
    const availabilityStatus = await checkDoctorEmailAvailability(value);
    if (availabilityStatus === "1") {
      return Promise.reject(
        new Error("Email già esistente, scegli un'altra email!")
      );
    } else if (availabilityStatus !== "0") {
      return Promise.reject(new Error("Errore di connessione o interno"));
    }
    return Promise.resolve();
  };

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Row>
        <Col span={20}>
          <Form.Item label="Studio">
            <Input value={studio.fullName} disabled />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Studio Master">
            <Switch
              checked={doctor.studioMaster}
              onChange={(checked) => handleInputChange("studioMaster", checked)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item label="Nome">
            <Input
              placeholder="Nome"
              type="text"
              value={doctor.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={11}>
          <Form.Item label="Cognome">
            <Input
              placeholder="Cognome"
              type="text"
              value={doctor.surname}
              onChange={(e) => handleInputChange("surname", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          {/* Aggiunto il name "email" e le regole di validazione */}
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Inserisci l'email" },
              { type: "email", message: "Inserisci un'email valida" },
              { validator: validateDoctorEmail },
            ]}
          >
            <Input
              placeholder="Email"
              type="email"
              value={doctor.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={11}>
            <Form.Item
            label="Telefono"
            name="telephone"
            rules={[
              { required: true, message: "Inserisci un numero di telefono" },
              {
              pattern: /^[0-9]{8,15}$/,
              message: "Inserisci un numero di telefono valido (8-15 cifre)",
              },
            ]}
            >
            <Input
              placeholder="Contatto telefonico"
              addonBefore={"+39"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDoctor({
                ...doctor,
                telephone: "+39" + e.target.value,
              })
              }
            />
            </Form.Item>
        </Col>
      </Row>
      {/* Aggiornato il Form.Item per Username con il validator asincrono */}
      <Form.Item
        label="Username"
        name="username"
        rules={[
          { required: true, message: "Inserisci l'username" },
          { validator: validateUsernameAvailability },
        ]}
      >
        <Input
          placeholder="Username"
          type="text"
          value={doctor.username}
          onChange={(e) => handleInputChange("username", e.target.value)}
        />
      </Form.Item>
      <Form.Item label="Password">
        <Input.Password
          placeholder="Password"
          value={doctor.password}
          onChange={(e) => handleInputChange("password", e.target.value)}
        />
      </Form.Item>
      <Form.Item
        label="Conferma Password"
        name="passwordConfirmation"
        dependencies={["password"]}
        rules={[
          { required: true, message: "Conferma la password" },
          { validator: validatePasswordConfirmation },
        ]}
      >
        <Input.Password
          placeholder="Conferma Password"
          value={doctor.passwordConfirmation}
          onChange={(e) =>
            handleInputChange("passwordConfirmation", e.target.value)
          }
        />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => handleInputChange("studio", studio.fullName)}
        >
          Aggiungi Dottore
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EditDoctorInfoX;